import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';
import TimecardIcon from '@material-ui/icons/Schedule';

import backgroundColor from '@material-ui/core/colors/indigo';


import { selectTimecardsList } from '../../../store/selectors';

const styles = theme => ({
  title: {
    backgroundColor: backgroundColor[500],
  },
});

const ImportLineItems = (props) => {
  const {
    classes,
    open,
    onClose,
    lineItems,
  } = props;

  return(
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="dense" variant="head">Description</TableCell>
            <TableCell padding="dense" variant="head" numeric>Quantity</TableCell>
            <TableCell padding="dense" variant="head" numeric>Unit Price</TableCell>
            <TableCell padding="dense" variant="head" numeric>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lineItems.map((lineItem, i) => {
            return (
              <TableRow key={i}>
                <TableCell padding="dense" variant="body">
                  {lineItem.description}
                </TableCell>
                <TableCell padding="dense" variant="body" numeric>
                  {lineItem.quantity}
                </TableCell>
                <TableCell padding="dense" variant="body" numeric>
                  {lineItem.unitPrice}
                </TableCell>
                <TableCell padding="dense" variant="body" numeric>
                  {lineItem.total}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
  );
}

const mapStateToProps = (state, props) => ({
  lineItems: state.formData.importTimeMaterials.lineItems,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ImportLineItems);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/ImportLineItems.jsx